import { merge } from 'lodash';

// English translations
import enCommon from './en/common.json';
import enNavigation from './en/navigation.json';
import enHabits from './en/habits.json';
import enSupport from './en/support.json';
import enCoaching from './en/coaching.json';
import enEducation from './en/education.json';
import enRewards from './en/rewards.json';
import enCategories from './en/categories.json';
import enAuth from './en/auth.json';
import enSettings from './en/settings.json';
import enLogs from './en/logs.json';
import enVideoCall from './en/videocall.json';
import enAvailability from './en/availability.json';
import enOtp from './en/otp.json';
import enMeals from './en/meals.json';
import enActivities from './en/activities.json';
import enSleep from './en/sleep.json';
import enLanding from './en/landing.json';

// English Dashboard translations (split by role)
import enDashboardCommon from './en/dashboard-common.json';
import enDashboardAdmin from './en/dashboard-admin.json';
import enDashboardCustomer from './en/dashboard-customer.json';
import enDashboardCoach from './en/dashboard-coach.json';
import enDashboardManager from './en/dashboard-manager.json';
import enDashboardInstructor from './en/dashboard-instructor.json';
import enDashboardProvider from './en/dashboard-provider.json';
import enDashboardExaminer from './en/dashboard-examiner.json';
import enDashboardVolunteer from './en/dashboard-volunteer.json';
import enDashboardPartner from './en/dashboard-partner.json';
import enDashboardNavigation from './en/dashboard-navigation.json';
import enDashboardCoordinator from './en/dashboard-coordinator.json';
import enDashboardMarketer from './en/dashboard-marketer.json';
import enVolunteerRegistration from './en/volunteer-registration.json';

// Arabic translations
import arCommon from './ar/common.json';
import arNavigation from './ar/navigation.json';
import arHabits from './ar/habits.json';
import arSupport from './ar/support.json';
import arCoaching from './ar/coaching.json';
import arEducation from './ar/education.json';
import arRewards from './ar/rewards.json';
import arCategories from './ar/categories.json';
import arAuth from './ar/auth.json';
import arSettings from './ar/settings.json';
import arLogs from './ar/logs.json';
import arVideoCall from './ar/videocall.json';
import arAvailability from './ar/availability.json';
import arOtp from './ar/otp.json';
import arMeals from './ar/meals.json';
import arActivities from './ar/activities.json';
import arSleep from './ar/sleep.json';
import arLanding from './ar/landing.json';

// Arabic Dashboard translations (split by role)
import arDashboardCommon from './ar/dashboard-common.json';
import arDashboardAdmin from './ar/dashboard-admin.json';
import arDashboardCustomer from './ar/dashboard-customer.json';
import arDashboardCoach from './ar/dashboard-coach.json';
import arDashboardManager from './ar/dashboard-manager.json';
import arDashboardInstructor from './ar/dashboard-instructor.json';
import arDashboardProvider from './ar/dashboard-provider.json';
import arDashboardExaminer from './ar/dashboard-examiner.json';
import arDashboardVolunteer from './ar/dashboard-volunteer.json';
import arDashboardPartner from './ar/dashboard-partner.json';
import arDashboardNavigation from './ar/dashboard-navigation.json';
import arDashboardCoordinator from './ar/dashboard-coordinator.json';
import arDashboardMarketer from './ar/dashboard-marketer.json';
import arVolunteerRegistration from './ar/volunteer-registration.json';

export type Language = 'en' | 'ar';

const en = merge(
  {},
  enCommon,
  enNavigation,
  enHabits,
  enSupport,
  enCoaching,
  enEducation,
  enRewards,
  enCategories,
  enAuth,
  enSettings,
  enLogs,
  { videoCall: enVideoCall },
  enAvailability,
  { otp: enOtp },
  enMeals,
  enActivities,
  enSleep,
  enLanding,
  // Dashboard translations (merged automatically)
  enDashboardCommon,
  enDashboardAdmin,
  enDashboardCustomer,
  enDashboardCoach,
  enDashboardManager,
  enDashboardInstructor,
  enDashboardProvider,
  enDashboardExaminer,
  enDashboardVolunteer,
  enDashboardPartner,
  enDashboardNavigation,
  enDashboardCoordinator,
  enDashboardMarketer,
  enVolunteerRegistration
);

const ar = merge(
  {},
  arCommon,
  arNavigation,
  arHabits,
  arSupport,
  arCoaching,
  arEducation,
  arRewards,
  arCategories,
  arAuth,
  arSettings,
  arLogs,
  { videoCall: arVideoCall },
  arAvailability,
  { otp: arOtp },
  arMeals,
  arActivities,
  arSleep,
  arLanding,
  // Dashboard translations (merged automatically)
  arDashboardCommon,
  arDashboardAdmin,
  arDashboardCustomer,
  arDashboardCoach,
  arDashboardManager,
  arDashboardInstructor,
  arDashboardProvider,
  arDashboardExaminer,
  arDashboardVolunteer,
  arDashboardPartner,
  arDashboardNavigation,
  arDashboardCoordinator,
  arDashboardMarketer,
  arVolunteerRegistration
);

export const translations = { en, ar };